// Action types for edit state
export const SET_EDIT_MODE = 'SET_EDIT_MODE';
export const RESET_EDIT_MODE = 'RESET_EDIT_MODE'; 